import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6)
    },
    panel: {
        maxWidth: 780,
        margin: '0 auto',
        padding: theme.spacing(4, 4.5),
        borderRadius: theme.spacing(3),
        background: theme.palette.type === 'dark'
            ? 'linear-gradient(145deg, rgba(29, 35, 48, 0.72), rgba(20, 24, 33, 0.68))'
            : 'linear-gradient(145deg, rgba(255, 255, 255, 0.72), rgba(244, 246, 253, 0.68))',
        backdropFilter: 'blur(14px) saturate(135%)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3),
        }
    },
    heading: {
        marginBottom: theme.spacing(2)
    },
    description: {
        maxWidth: 680
    }
});

const Competitions = ({ classes }) => {
    return (
        <div className={classes.root}>
            <Container>
                <Paper elevation={0} className={classes.panel}>
                    <Typography variant="h5" className={classes.heading}>
                        Competitions
                    </Typography>
                    <Typography variant="body1" className={classes.description}>
                        Competitions are planned for a future PINN Hub release, but they are not live in the current application yet.
                    </Typography>
                </Paper>
            </Container>
        </div>
    );
};

export default withStyles(styles)(Competitions);
